export const state = {
    data: {},
}

export const mutations = {
    setData(state, payload) {
        state.data = payload;
    }
}
